import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a64d9b76&class=full-heigth&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a64d9b76')) {
      api.createRecord('a64d9b76', component.options)
    } else {
      api.reload('a64d9b76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a64d9b76&class=full-heigth&", function () {
      api.rerender('a64d9b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/member/index.vue"
export default component.exports